$(document).ready(function() {

    // Mascaras formulário

    $('.cep').mask('00000-000');
    $('.phone_with_ddd').mask('(00) 0 0000-0000');
    $('.oldphone_with_ddd').mask('(00) 0000-0000');
    $('.number-only').mask('00000');
    $('.cpf').mask('000.000.000-00', {
        reverse: true,
    });
    $('.cnpj').mask('00.000.000/0000-00', {
        reverse: true,
    });
    $('.rg').mask('00.000.000-0', {
        reverse: true,
    });

    // CEP AUTOMATICO 

    $('#CEP_credenciar').blur(function() {
        var cep = this.value.replace(/[^0-9]/, '');

        if (cep.length != 8) {
            return false;
        }


        var url = 'https://viacep.com.br/ws/' + cep + '/json/';

        $.getJSON(url, function(dadosRetorno) {
            try {
                $('#RUA_credenciar').val(dadosRetorno.logradouro);
                $('#BAIRRO_credenciar').val(dadosRetorno.bairro);
                $('#CIDADE_credenciar').val(dadosRetorno.localidade);
                $('#ESTADO_credenciar').val(dadosRetorno.uf);
            } catch (ex) { return '' }
        });
    });

    $('#CEPPF_credenciar').blur(function() {
        var ceppf = this.value.replace(/[^0-9]/, '');

        if (ceppf.length != 8) {
            return false;
        }

        var urlpf = 'https://viacep.com.br/ws/' + ceppf + '/json/';

        $.getJSON(urlpf, function(dadosRetornopf) {
            try {
                $('#RUAPF_credenciar').val(dadosRetornopf.logradouro);
                $('#BAIRROPF_credenciar').val(dadosRetornopf.bairro);
                $('#CIDADEPF_credenciar').val(dadosRetornopf.localidade);
                $('#ESTADOPF_credenciar').val(dadosRetornopf.uf);
            } catch (expf) { return '' }
        });
    });

    // Remote <br>

    $('.qwp_credenciar-empresa br').remove();

    // Verificar se os campos estão preenchidos

    // Verificação geral

    $('#first-step-button').attr('disabled', true);

    $('#second-step-button').attr('disabled', true);

    $('#theird-step-button').attr('disabled', true);

    $('.FIRST-STEP-CREDENCIAR').css('display', 'block');

    $('.SECOND-STEP-CREDENCIAR').css('display', 'none');

    $('.THEIRD-STEP-CREDENCIAR').css('display', 'none');

    $('.FOURTH-STEP-CREDENCIAR').css('display', 'none');

    // Verificação da primeira etapa

    $('.input_credenciar1').change(function() {
        if ($('#CNPJ_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#RAZAOSOCIAL_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#NOMEFANTASIA_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#EMAIL_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#TELEFONE_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#CEP_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#RUA_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#NUMERO_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#ESTADO_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#CIDADE_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else if ($('#BAIRRO_credenciar').val().length === 0) {
            $('#first-step-button').attr('disabled', true);
        } else {
            $('#first-step-button').attr('disabled', false);
            $('#first-step-button').css('opacity', '1');

            $('#first-step-button').click(function() {
                $('.FIRST-STEP-CREDENCIAR').css('display', 'none');
                $('.SECOND-STEP-CREDENCIAR').css('display', 'block');
            });
        }
    });

    // Verificação da segunda etapa

    $('.input_credenciar2').change(function() {
        if ($('#NOMECOMPLETO_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#CPF_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#RG_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#ESTADOCIVIL_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#PROFISSAO_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#NASCIONALIDADE_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#RUAPF_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#CEPPF_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#NUMEROPF_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#ESTADOPF_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#CIDADEPF_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else if ($('#BAIRROPF_credenciar').val().length === 0) {
            $('#second-step-button').attr('disabled', true);
        } else {
            $('#second-step-button').attr('disabled', false);
            $('#second-step-button').css('opacity', '1');

            $('#second-step-button').click(function() {
                $('.THEIRD-STEP-CREDENCIAR').css('display', 'block');
                $('.SECOND-STEP-CREDENCIAR').css('display', 'none');
            });
        }
    });

    // Verificação da terceira etapa

    $('.input_credenciar3').change(function() {
        if ($('#BANCODOESTABELECIMENTO_credenciar').val().length === 0) {
            $('#theird-step-button').attr('disabled', true);
        } else if ($('#TIPODECONTA_credenciar').val().length === 0) {
            $('#theird-step-button').attr('disabled', true);
        } else if ($('#AGENCIA_credenciar').val().length === 0) {
            $('#theird-step-button').attr('disabled', true);
        } else if ($('#NUMERODACONTA_credenciar').val().length === 0) {
            $('#theird-step-button').attr('disabled', true);
        } else if ($('#CPFCNPJDACONTA_credenciar').val().length === 0) {
            $('#theird-step-button').attr('disabled', true);
        } else {
            $('#theird-step-button').attr('disabled', false);
            $('#theird-step-button').css('opacity', '1');

            /* $('#theird-step-button').click(function () {
             
            }); */
        }
    });


    $('#theird-step-button').on('click', function() {
        var main_url = 'https://test.ecx.com.br/';
        // https://test.ecx.com.br/
        var data_cred_CNPJ = $('#CNPJ_credenciar').val();
        var data_cred_EMAIL = $('#EMAIL_credenciar').val();
        var data_cred_NOMEFANTASIA = $('#NOMEFANTASIA_credenciar').val();
        var data_cred_RAZAOSOCIAL = $('#RAZAOSOCIAL_credenciar').val();
        var data_cred_TELEFONE = $('#TELEFONE_credenciar').val();
        var data_cred_TELEFONE2 = $('#TELEFONE2_credenciar').val();
        var data_cred_RUA = $('#RUA_credenciar').val();
        var data_cred_CEP = $('#CEP_credenciar').val();
        var data_cred_NUMERO = $('#NUMERO_credenciar').val();
        var data_cred_ESTADO = $('#ESTADO_credenciar').val();
        var data_cred_CIDADE = $('#CIDADE_credenciar').val();
        var data_cred_BAIRRO = $('#BAIRRO_credenciar').val();
        var data_cred_COMPLEMENTO = $('#COMPLEMENTO_credenciar').val();
        var data_cred_ramo = $('#sel_ramo').val();

        var data_cred_NOMECOMPLETO = $('#NOMECOMPLETO_credenciar').val();
        var data_cred_CPF = $('#CPF_credenciar').val();
        var data_cred_RG = $('#RG_credenciar').val();
        var data_cred_ESTADOCIVIL = $('#ESTADOCIVIL_credenciar').val();
        var data_cred_PROFISSAO = $('#PROFISSAO_credenciar').val();
        var data_cred_NASCIONALIDADE = $('#NASCIONALIDADE_credenciar').val();
        var data_cred_RUAPF = $('#RUAPF_credenciar').val();
        var data_cred_COMPLEMENTOPF = $('#COMPLEMENTOPF_credenciar').val();
        var data_cred_CEPPF = $('#CEPPF_credenciar').val();
        var data_cred_NUMEROPF = $('#NUMEROPF_credenciar').val();
        var data_cred_ESTADOPF = $('#ESTADOPF_credenciar').val();
        var data_cred_CIDADEPF = $('#CIDADEPF_credenciar').val();
        var data_cred_BAIRROPF = $('#BAIRROPF_credenciar').val();

        var data_cred_BANCODOESTABELECIMENTO = $('#BANCODOESTABELECIMENTO_credenciar').val();
        var data_cred_TIPODECONTA = $('#TIPODECONTA_credenciar').val();
        var data_cred_AGENCIA = $('#AGENCIA_credenciar').val();
        var data_cred_NUMERODACONTA = $('#NUMERODACONTA_credenciar').val();
        var data_cred_CPFCNPJDACONTA = $('#CPFCNPJDACONTA_credenciar').val();

        const remove = (sel) => document.querySelectorAll(sel).forEach(el => el.remove());

        console.log(data_cred_CNPJ)
            // Inserir função pessoa juridica aqui 

        $.ajax({
            method: 'POST',
            url: main_url + '/wp-content/themes/ecx/app/api/formPF.php',
            data: {
                cred_CNPJ: data_cred_CNPJ,
                cred_EMAIL: data_cred_EMAIL,
                cred_NOMEFANTASIA: data_cred_NOMEFANTASIA,
                cred_RAZAOSOCIAL: data_cred_RAZAOSOCIAL,
                cred_TELEFONE: data_cred_TELEFONE,
                cred_TELEFONE2: data_cred_TELEFONE2,
                cred_ramo: data_cred_ramo,
                cred_RUA: data_cred_RUA,
                cred_CEP: data_cred_CEP,
                cred_NUMERO: data_cred_NUMERO,
                cred_ESTADO: data_cred_ESTADO,
                cred_CIDADE: data_cred_CIDADE,
                cred_BAIRRO: data_cred_BAIRRO,
                cred_COMPLEMENTO: data_cred_COMPLEMENTO,
                cred_NOMECOMPLETO: data_cred_NOMECOMPLETO,
                cred_CPF: data_cred_CPF,
                cred_RG: data_cred_RG,
                cred_ESTADOCIVIL: data_cred_ESTADOCIVIL,
                cred_PROFISSAO: data_cred_PROFISSAO,
                cred_NASCIONALIDADE: data_cred_NASCIONALIDADE,
                cred_RUAPF: data_cred_RUAPF,
                cred_COMPLEMENTOPF: data_cred_COMPLEMENTOPF,
                cred_CEPPF: data_cred_CEPPF,
                cred_NUMEROPF: data_cred_NUMEROPF,
                cred_ESTADOPF: data_cred_ESTADOPF,
                cred_CIDADEPF: data_cred_CIDADEPF,
                cred_BAIRROPF: data_cred_BAIRROPF,
                cred_BANCODOESTABELECIMENTO: data_cred_BANCODOESTABELECIMENTO,
                cred_TIPODECONTA: data_cred_TIPODECONTA,
                cred_AGENCIA: data_cred_AGENCIA,
                cred_NUMERODACONTA: data_cred_NUMERODACONTA,
                cred_CPFCNPJDACONTA: data_cred_CPFCNPJDACONTA,
            },


            beforeSend: function() {
                var load = '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
                $('button#theird-step-button').html(load);
            },
            success: function(result) {
                remove('.error');

                $('button#theird-step-button').html('Enviar <i class="fa-solid fa-angle-right"></i>');
                console.log(typeof result)
                if (result.toString() == 'OK' || result.toString() == '' || result.search('400') != '-1') {

                    // Inserir função pessoa fisica aqui
                    $.ajax({
                        method: 'POST',
                        url: main_url + '/wp-content/themes/ecx/app/api/formPJ.php',
                        data: {
                            cred_CNPJ: data_cred_CNPJ,
                            cred_EMAIL: data_cred_EMAIL,
                            cred_NOMEFANTASIA: data_cred_NOMEFANTASIA,
                            cred_RAZAOSOCIAL: data_cred_RAZAOSOCIAL,
                            cred_TELEFONE: data_cred_TELEFONE,
                            cred_TELEFONE2: data_cred_TELEFONE2,
                            cred_ramo: data_cred_ramo,
                            cred_RUA: data_cred_RUA,
                            cred_CEP: data_cred_CEP,
                            cred_NUMERO: data_cred_NUMERO,
                            cred_ESTADO: data_cred_ESTADO,
                            cred_CIDADE: data_cred_CIDADE,
                            cred_BAIRRO: data_cred_BAIRRO,
                            cred_COMPLEMENTO: data_cred_COMPLEMENTO,
                            cred_NOMECOMPLETO: data_cred_NOMECOMPLETO,
                            cred_CPF: data_cred_CPF,
                            cred_RG: data_cred_RG,
                            cred_ESTADOCIVIL: data_cred_ESTADOCIVIL,
                            cred_PROFISSAO: data_cred_PROFISSAO,
                            cred_NASCIONALIDADE: data_cred_NASCIONALIDADE,
                            cred_RUAPF: data_cred_RUAPF,
                            cred_COMPLEMENTOPF: data_cred_COMPLEMENTOPF,
                            cred_CEPPF: data_cred_CEPPF,
                            cred_NUMEROPF: data_cred_NUMEROPF,
                            cred_ESTADOPF: data_cred_ESTADOPF,
                            cred_CIDADEPF: data_cred_CIDADEPF,
                            cred_BAIRROPF: data_cred_BAIRROPF,
                            cred_BANCODOESTABELECIMENTO: data_cred_BANCODOESTABELECIMENTO,
                            cred_TIPODECONTA: data_cred_TIPODECONTA,
                            cred_AGENCIA: data_cred_AGENCIA,
                            cred_NUMERODACONTA: data_cred_NUMERODACONTA,
                            cred_CPFCNPJDACONTA: data_cred_CPFCNPJDACONTA,
                        },
                        beforeSend: function() {
                            var load = '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
                            $('button#theird-step-button').html(load);
                        },
                        success: function(result) {
                            // Use like:
                            remove('.error');
                            console.log(result);

                            $('button#theird-step-button').html('Enviar <i class="fa-solid fa-angle-right"></i>');
                            if (result == 'OK' || result == '' || result.search('400') != '-1') {
                                $('.THEIRD-STEP-CREDENCIAR').css('display', 'none');
                                $('.FOURTH-STEP-CREDENCIAR').css('display', 'block');
                                console.log('cred_email Iniciada')
                                $.ajax({
                                    method: 'POST',
                                    url: main_url + '/wp-content/themes/ecx/app/api/sendCredMail.php',
                                    data: {
                                        cred_CNPJ: data_cred_CNPJ,
                                    },
                                    success: function(result) {
                                        console.log(result)
                                    },
                                })
                            } else {
                                $('.THEIRD-STEP-CREDENCIAR').append('<p>Houve um erro ao enviar seus dados juridicos</p>' + result + '</p>');

                            }
                        },
                    });

                } else {
                    $('.THEIRD-STEP-CREDENCIAR').append('<p>Houve um erro ao enviar seus dados pessoais</p><p class="error"><p class="error">' + result + '</p>');

                }
            },
        });

    });


    /* function pjSend() {
        console.log('chamar função pj');
    } */
});


// WEBPACK FOOTER //
// ./scripts/routes/credenciar-loja.js